export const EMOJI_MAPPINGS: any = new Map([
   ['bahrain', ['🇧🇭']],
   ['saudi', ['💣', '🚀', '💥']],
   ['australia', ['']],
   ['marino', ['']],
   ['miami', ['']],
   ['spain', ['']],
   ['monaco', ['🇧🇭']],
   ['azerbaijan', ['🇸🇦']],
   ['canada', ['']],
   ['britain', ['']],
   ['austria', ['']],
   ['france', ['']],
   ['hungary', ['']],
   ['belgium', ['']],
   ['dutch', ['']],
   ['italy', ['']],
   ['singapore', ['']],
   ['japan', ['']],
   ['cota', ['']],
   ['mexico', ['']],
   ['brazil', ['']],
   ['uae', ['']],
]);
